import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Divider,
  IconButton,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import { themePalette } from "../../constants/Theme/colors";

export default function UserProfileDialog(props) {
  const { open, close, title, dialogSize, dialogContent } = props;

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Dialog fullScreen={fullScreen} open={open} fullWidth maxWidth={dialogSize}>
      <DialogTitle sx={{ pl: "28px", pr: 4, pt: 3, pb: 2 }}>
        <Typography
          variant="titleLarge"
          sx={{ color: themePalette.palette.primary.main }}
        >
          {title}
        </Typography>
        <IconButton
          onClick={close}
          sx={{
            float: "right",
            pr: 0,
            height: "10px",
            "&:hover": { backgroundColor: "unset" },
          }}
        >
          <CloseIcon
            sx={{
              color: themePalette.palette.primary.main,
              fontSize: 26,
              mt: 2,
            }}
          />
        </IconButton>
      </DialogTitle>
      <Divider
        sx={{
          border: `1px solid ${theme.palette.common.dividerColor}`,
          opacity: "0.7",
        }}
      />
      <DialogContent sx={{ px: 4 }}>{dialogContent}</DialogContent>
    </Dialog>
  );
}
